export default __webpack_public_path__ + "static/media/trustwallet.eb75d105.svg";